export enum EnumStatutCommande {
    Termine,
    EnCours,
    Archive,
    Toutes,
    NonArchive,
    
}